


import React, { useEffect } from 'react';
import {
    Modal,
    ModalOverlay,
    ModalContent,
    ModalHeader,
    ModalFooter,
    ModalBody,
    ModalCloseButton,
    Stack,
    Select,
    Text,
    HStack,
    Spacer,
    Box,
} from '@chakra-ui/react'
import Input from './Input';
import { useState } from 'react';
import { FaUser, FaUserAlt } from "react-icons/fa";
import Button from './Button';
import { CreateSRA, CreateUser, GetAllStores, GetAllSuppliers, GetAllUserType, UpdateProcurementAPI, UpdateSRAAPI } from '../Utils/ApiCalls';
import { AiOutlineFieldNumber, AiTwotoneMail } from 'react-icons/ai';
import ProductCard from './ProductCard';
import MsgCallback from './MsgCallback';
import { TbFileInvoice } from 'react-icons/tb';
import { BsCalendar2Date, BsFilePostFill } from 'react-icons/bs';
import { BiUser, BiUserPin } from 'react-icons/bi';
import jwtDecode from 'jwt-decode';
import { isEmergency } from '../Authetication';



export default function UpdateDeviceAssingmentProcument({ isOpen, onClose, actionType, singleItem }) {


    let ImsToken = JSON.parse(localStorage.getItem("ImsToken"))

    let onlineUser = jwtDecode(ImsToken)

    const [Payload, setPayload] = useState({

        suppliersname: "",
        invoicenumber: "",
        raised: onlineUser.unique_name,
        itemnos: "",
        costcenter: "",
        received: "",
        postedonstockcard: "",
        inwardsfreight: "",
        customduty: "",
        pushtoiandqa: null,
        datereceived: ""

    });


    const [errorMsg, setErrorMsg] = useState({
        status: false,
        msg: ""
    });

    const [SuccessMsg, setSuccessMsg] = useState({
        status: false,
        msg: "sdfgvhbnm"
    });


    const [Loading, setLoading] = useState(false);




    const handleSRA = (e) => {
        setPayload({ ...Payload, [e.target.id]: e.target.value })

    }
   

    const UpdateProcurement = async () => {

        try {
            setLoading(true)
            let result = await UpdateProcurementAPI(Payload, singleItem[0]._id);
            console.log("result UpdateProcurement", result);
            if (result.status == true) {
                setLoading(false)
                setErrorMsg({
                    status: false,

                })

                setSuccessMsg({
                    status: true,
                    msg: "Procurement Updated successfully"
                })

               

                setTimeout(() => {
                    setSuccessMsg({
                        status: false,

                    })

                    onClose()
                }, 3000);

            } else {
                setLoading(false)

                setErrorMsg({
                    status: true,
                    msg: result.msg
                })

            }


        } catch (e) {

            setLoading(false)
            setErrorMsg({
                status: true,
                msg: e.message
            })
            console.error('Error:', e.message);
        }



    }
  



    useEffect(() => {
       


        setPayload({
            sranumber: singleItem[0]?.sranumber,
            suppliersname: singleItem[0]?.suppliersname,
            invoicenumber: singleItem[0]?.invoicenumber,
            itemnos: singleItem[0]?.itemnos,
            costcenter: singleItem[0]?.costcenter,
            raised: onlineUser.unique_name,
            received: singleItem[0]?.received,
            postedonstockcard: singleItem[0]?.postedonstockcard,
            inwardsfreight: singleItem[0]?.inwardsfreight,
            customduty: singleItem[0]?.customduty,
            datereceived: singleItem[0]?.datereceived
        })




    }, [isOpen, actionType]);

    return (



        <Modal isOpen={isOpen} onClose={onClose} isCentered scrollBehavior={"inside"} size={"xl"}>
            <ModalOverlay />
            <ModalContent>
                <ModalHeader>Update Procurement</ModalHeader>
                <ModalCloseButton />
                <ModalBody>

                    <Box>
                        <Stack spacing={"15px"}>

                            <HStack spacing={"10px"}>
                                <Input leftIcon={<BiUser />} iconColor="black" labelBg='#fff' label='Suppliers Name' id="suppliersname" type='text' value={Payload.suppliersname} val={Payload.suppliersname != "" ? true : false} onChange={handleSRA} />

                                <Select _focus={{ borderColor: "blue.blue400" }} placeholder='Push to I&QA' fontWeight={"400"} fontSize={Payload.pushtoiandqa !== "" ? "16px" : "12px"} id='pushtoiandqa' value={Payload.pushtoiandqa} onChange={handleSRA} >
                                    <option value={`${true}`}>True</option>
                                    <option value={`${false}`}>False</option>


                                </Select>
                            </HStack>





                            <HStack spacing={"10px"}>
                                <Input leftIcon={<TbFileInvoice />} iconColor="black" labelBg='#fff' label='Invoice Number' id="invoicenumber" type='number' value={Payload.invoicenumber} val={Payload.invoicenumber != "" ? true : false} onChange={handleSRA} />
                                <Input leftIcon={<TbFileInvoice />} iconColor="black" labelBg='#fff' label='IIR number' id="itemnos" type='number' value={Payload.itemnos} val={Payload.itemnos != "" ? true : false} onChange={handleSRA} />

                            </HStack>
                            <HStack spacing={"10px"}>
                                <Input leftIcon={<AiOutlineFieldNumber />} iconColor="black" labelBg='#fff' label='Cost Center' id="costcenter" type='text' value={Payload.costcenter} val={Payload.costcenter != "" ? true : false} onChange={handleSRA} />
                                <Input leftIcon={<BiUserPin />} iconColor="black" labelBg='#fff' label='Raised by' id="raised" type='text' value={onlineUser.unique_name} val={Payload.raised != "" ? true : false} onChange={handleSRA} />

                            </HStack>
                            <HStack spacing={"10px"}>
                                <Input leftIcon={<BiUserPin />} iconColor="black" labelBg='#fff' label='Received by' id="received" type='text' value={Payload.received} val={Payload.received != "" ? true : false} onChange={handleSRA} />
                                <Input leftIcon={<BsCalendar2Date />} iconColor="black" label='Date Received' labelBg='#fff' id="datereceived" type='date' value={Payload.datereceived} val={Payload.datereceived != "" ? true : false} onChange={handleSRA} />


                            </HStack>

                            <HStack spacing={"10px"}>
                                <Input leftIcon={<AiOutlineFieldNumber />} iconColor="black" labelBg='#fff' label='inwards Freight' id="inwardsfreight" type='number' value={Payload.inwardsfreight} val={Payload.inwardsfreight != "" ? true : false} onChange={handleSRA} />
                                <Input leftIcon={<AiOutlineFieldNumber />} iconColor="black" labelBg='#fff' label='Custom Duty' id="customduty" type='number' value={Payload.customduty} val={Payload.customduty != "" ? true : false} onChange={handleSRA} />

                            </HStack>

                            <HStack spacing={"10px"}>
                                <Input leftIcon={<BsFilePostFill />} iconColor="black" labelBg='#fff' label='Posted on Stock Card' id="postedonstockcard" type='text' value={Payload.postedonstockcard} val={Payload.postedonstockcard != "" ? true : false} onChange={handleSRA} />

                            </HStack>




                        </Stack>

                        <Button mt="14px" isLoading={Loading}
                            disabled={Payload.firstname != "" && Payload.lastname != "" && Payload.email != "" && Payload.store != "" && Payload.staffid != "" && Payload.usertype != "" ? false : true}
                            onClick={UpdateProcurement}>Update</Button>
                    </Box>



                    <MsgCallback errorMsg={errorMsg} SuccessMsg={SuccessMsg} />

                </ModalBody>

                <ModalFooter>


                </ModalFooter>
            </ModalContent>
        </Modal>

    )
}

